import { render, staticRenderFns } from "./DashTopbar.vue?vue&type=template&id=2461961a&"
import script from "./DashTopbar.vue?vue&type=script&lang=js&"
export * from "./DashTopbar.vue?vue&type=script&lang=js&"
import style0 from "./DashTopbar.vue?vue&type=style&index=0&id=2461961a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports